import React, { useEffect, useState } from 'react';
import { IMAGE_W_TITLE_BODY } from '../../../../constants/UiBuilderConst';
import CustomUiBuilderTextField from '../../../../shared/form-controls/custom-ui-builder-text-field/Custom-UI-Builder-Text-Field';
import HotelModuleSelector from '../../../../shared/ui-builder/hotel-module-selector/Hotel-Module-Selector';
import ModuleIdSelector from '../../../../shared/ui-builder/module-id-selector/Module-Id-Selector';
import RedirectSelector from '../../../../shared/ui-builder/redirect-selector/Redirect-Selector';
import DraggableTabsList from '../../../../shared/draggable-tabs-list/Draggable-Tabs-List';
import '../Component-Library.scss';
import MediaSelector from '../../../../shared/ui-builder/media-selector/Media-Selector';

//3 DBL w/IMG Title, & Body
const ImageComponentWithTitleAndBody = (props) => {
  const { onItemChange, config, groupId, handleError, componentNdx } = props;
  const [title, setTitle] = useState(config.titleH1 ? config.titleH1 : '');
  const [body, setBody] = useState(config.body ? config.body : '');
  const [hotelModule, setHotelModule] = useState(config?.hotelModule || '');

  const initialSlide = [
    {
      id: `image_1`,
      label: `Image 1`,
      imgURL: null,
      videoURL: null,
      titleH3: '',
      hotelModuleId: '',
      redirectLink: {
        connection: '',
        linkId: '',
        isActive: false,
      },
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
    },
    {
      id: `image_2`,
      label: `Image 2`,
      imgURL: null,
      videoURL: null,
      titleH3: '',
      hotelModuleId: '',
      redirectLink: {
        connection: '',
        linkId: '',
        isActive: false,
      },
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
    },
  ];
  const [slidesList, setSlidesList] = useState(
    config.slides && config.slides.length
      ? config.slides.map((e, index) => {
          return {
            ...e,
            id: `image_${index + 1}`,
            label: `Image ${index + 1}`,
          };
        })
      : initialSlide,
  );
  const [activeTabIndex, setActveTabIndex] = useState(0);
  const [activeTabContent, setActveTabContent] = useState(slidesList[0]);
  const [error, setError] = useState(null);
  const [isSwapEnabled, setIsSwapEnabled] = useState(false);

  useEffect(() => {
    onItemChange({
      componentName: IMAGE_W_TITLE_BODY,
      config: {
        titleH1: title || hotelModule,
        body: body,
        hotelModule: hotelModule,
        slides: slidesList.map(({ id, label, ...keepAttrs }) => keepAttrs),
      },
    });
  }, [title, body, slidesList, hotelModule, isSwapEnabled]);

  useEffect(() => {
    if (handleError && handleError.length > 0) {
      setIsSwapEnabled(false);
      const currError = handleError.find(
        (getError) => getError.pos === componentNdx && getError.id === IMAGE_W_TITLE_BODY,
      );
      if (currError && currError.slides.length > 0) {
        const sliderNdx = Math.min.apply(
          Math,
          currError.slides.map((o) => o.pos),
        );
        setActveTabIndex(sliderNdx);
        setActveTabContent(slidesList[sliderNdx]);
      }
      setError(currError ?? null);
    }
  }, [handleError]);

  const onTabChange = (e, value) => {
    setActveTabIndex(value);
    setActveTabContent(slidesList[value]);
  };

  const setErrorField = (field, val) => {
    if (field !== 'redirect') {
      const trimmed = typeof val === 'string' ? val?.trim() : val;
      return trimmed ? '' : 'required';
    }
    if (val?.type) return '';
    return 'required';
  };

  const handleTabData = (val, slideContent, field, moduleName) => {
    const value = val && val?.target ? val?.target?.value : val;
    const thisErr = setErrorField(field, value);
    const newSlidesErr = slidesList?.map((_, idx) => {
      const prev = error?.slides?.find((e) => e?.pos === idx) || { pos: idx };
      return idx === activeTabIndex ? { ...prev, [field]: thisErr } : prev;
    });
    setError({ config: error?.config || {}, slides: newSlidesErr });
    switch (field) {
      case 'titleH3':
        slideContent.titleH3 = val.target.value;
        break;
      case 'imgURL':
        slideContent.imgURL = val;
        break;
      case 'hotelModuleId':
        slideContent.hotelModuleId = val ? val : '';
        slideContent.titleH3 = moduleName ? moduleName : '';
        break;
      case 'redirect':
        slideContent.redirectLink.connection = val.type;
        slideContent.redirectLink.linkId = val.value;
        break;
      case 'isActive':
        slideContent.redirectLink.isActive = val;
        break;
      case 'isVideo':
        slideContent.isVideo = val;
        break;
      case 'shadowOverlay':
        slideContent.shadowOverlay = val;
        break;
      case 'videoURL':
        slideContent.videoURL = val;
        break;
      case 'loopPlayBack':
        slideContent.loopPlayBack = val;
        break;
      default:
        break;
    }

    setSlidesList(
      slidesList.map((slide, index) => {
        if (index === activeTabIndex) {
          return slideContent;
        } else {
          return slide;
        }
      }),
    );
  };

  const onChangeHotelModule = (val, moduleName) => {
    if (val) {
      setHotelModule(val);
      onChangeTitle(moduleName);
    } else {
      setHotelModule('');
      onChangeTitle('');
    }
    const tempSlidesList = slidesList.map((slide) => {
      return { ...slide, hotelModuleId: '', titleH3: '' };
    });
    setSlidesList(tempSlidesList);
    setActveTabContent(tempSlidesList[activeTabIndex]);
  };
  const onChangeTitle = (e) => {
    const titleErr = setErrorField('titleH1', e);
    setError({
      config: { ...error?.config, titleH1: titleErr },
      slides: error?.slides || [],
    });
    setTitle(e);
  };

  const onChangeBody = (e) => {
    if (error) {
      const currError = { ...error };
      const currConfigError = {
        ...currError.config,
        body: setErrorField('body', e),
      };
      currError.config = currConfigError;
      setError(currError);
    }
    setBody(e);
  };

  const hasError = (key, isReturnString = false) => {
    const hasSliderError = error?.slides?.find(
      (errorSlider) =>
        errorSlider.pos === activeTabIndex &&
        (errorSlider[key] === 'required' || errorSlider[key] === 'validUrl'),
    );
    if (isReturnString && hasSliderError) return hasSliderError?.videoURL;
    if (hasSliderError) return true;
    return false;
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const newTabs = slidesList;
    const draggedTab = newTabs.splice(result.source.index, 1)[0];
    newTabs.splice(result.destination.index, 0, draggedTab);
    setActveTabIndex(result.destination.index);
    setActveTabContent(draggedTab);
    setSlidesList(newTabs);
    setIsSwapEnabled(true);
    onItemChange({
      componentName: IMAGE_W_TITLE_BODY,
      config: {
        titleH1: title || hotelModule,
        body: body,
        hotelModule: hotelModule,
        slides: slidesList.map(({ id, label, ...keepAttrs }) => keepAttrs),
      },
    });
  };

  return (
    <div className='row mb-2 mx-4'>
      <div className='col-md-12'>
        <div className='col-md-12 pe-4'>
          <HotelModuleSelector
            hotelModule={hotelModule}
            onChangeHotelModule={(e, moduleName) => onChangeHotelModule(e, moduleName)}
          />
        </div>
        <div className='row mb-3'>
          <div className='col-md-12 pe-5 my-2'>
            <div className='col-md-12'>
              <CustomUiBuilderTextField
                label='H1 Title'
                required={!Boolean(hotelModule)}
                className='col-md-12'
                value={title}
                onChangeInput={(e) => onChangeTitle(e.target.value)}
                maxLength={40}
                isAdornment={true}
                endAdornment={true}
                error={
                  !isSwapEnabled && !hotelModule && error?.config?.titleH1 === 'required'
                    ? true
                    : false
                }
              />
            </div>
            <div className='col-md-12 mt-2 mb-4'>
              <CustomUiBuilderTextField
                label='Body 1'
                required={true}
                className='col-md-12'
                value={body}
                onChangeInput={(e) => onChangeBody(e.target.value)}
                maxLength={500}
                isAdornment={true}
                endAdornment={true}
                error={!isSwapEnabled && error?.config?.body === 'required' ? true : false}
                multiline={true}
              />
            </div>
          </div>
          <div className='col-md-12 slide-tabs d-flex'>
            <DraggableTabsList
              onDragEnd={onDragEnd}
              tabs={slidesList}
              onTabChange={onTabChange}
              activeTabIndex={activeTabIndex}
            />
          </div>
          <div className='col-md-12 pe-5'>
            <div className='col-md-12'>
              {hotelModule && (
                <div className='col-md-12 mt-3'>
                  <ModuleIdSelector
                    hotelModule={hotelModule}
                    hotelModuleId={activeTabContent.hotelModuleId}
                    onChangeHotelModuleId={(e, moduleName) =>
                      handleTabData(e.target.value, activeTabContent, 'hotelModuleId', moduleName)
                    }
                  />
                </div>
              )}
              <CustomUiBuilderTextField
                label='H3 Title'
                required={!Boolean(activeTabContent.hotelModuleId)}
                className='col-md-12 mt-3'
                value={activeTabContent.titleH3}
                onChangeInput={(e) => handleTabData(e, activeTabContent, 'titleH3')}
                maxLength={100}
                isAdornment={true}
                endAdornment={true}
                error={
                  activeTabContent.hotelModuleId ? false : !isSwapEnabled && hasError('titleH3')
                }
              />
              <MediaSelector
                groupId={groupId}
                titleH2={'Image'}
                height={330}
                width={330}
                matrix={'px'}
                handleTabData={handleTabData}
                activeTabContent={activeTabContent}
                isSwapEnabled={isSwapEnabled}
                hasError={hasError}
                setIsSwapEnabled={setIsSwapEnabled}
                ratio={'1:1'}
              />
              <div className='col-md-12 mt-4'>
                <RedirectSelector
                  onValueChange={(e) => handleTabData(e, activeTabContent, 'redirect')}
                  redirectType={activeTabContent.redirectLink.connection}
                  value={activeTabContent.redirectLink.linkId}
                  onRedirectChange={(e) => {
                    handleTabData(e, activeTabContent, 'isActive');
                  }}
                  isActive={activeTabContent.redirectLink.isActive}
                  error={!isSwapEnabled && hasError('redirect')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageComponentWithTitleAndBody;
